export const ENTITY_NAME = 'USER_';
export const GET_SUBJECT_LINK_USER="GET_SUBJECT_LINK_USER";
export const DEL_SUBJECT_LINK_EL = "DEL_SUBJECT_LINK_EL";
export const CLEAR_DATA_SUBJECT_LINK = "CLEAR_DATA_SUBJECT_LINK"
